import StateModel from "User/store/models/stateModel";
import InvalidArgumentException from "Exceptions/invalidArgumentException";

const mutations = {
	/** @param {StateModel} state */
	LOG_USER_IN(state, payload) {
		if (payload === null || payload === undefined) throw new InvalidArgumentException("payload", payload);

		state.userName = payload.userName;
		state.userLogged = payload.userLogged;
	},
	LOG_USER_OUT(state) {
		state.userName = "";
		state.userLogged = false;
	}
};
export { mutations };